import React from 'react';
import { connect } from 'react-redux';
import { ModelEditorFactory } from '@leverege/ui-plugin';
import { UserSettings } from '@leverege/ui-redux';
import { UserSettingModelEditor } from "../../views/userSettings/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
class SettingsModelScreen extends React.Component {
  render() {
    const {
      model,
      name,
      icon,
      settingsPath,
      versionsPath
    } = this.props;
    const editor = ModelEditorFactory.get(model);
    return /*#__PURE__*/_jsx(UserSettingModelEditor, {
      titleVariant: "screenTitle",
      title: name,
      titleIcon: icon,
      editor: editor,
      value: model,
      settingsPath: settingsPath,
      versionsPath: versionsPath
    });
  }
}
export default connect((state, props) => {
  const {
    settingsPath
  } = props;
  return {
    model: UserSettings.get(state, settingsPath, {
      returnPromise: false
    })
  };
})(SettingsModelScreen);